module.exports = __webpack_public_path__ + "img/email.ccbc9901.svg";